import _ from 'lodash';
import * as ace from 'ace-builds';
import themeXCodeUrl from 'ace-builds/src-noconflict/theme-xcode.js?url';
import monokaiCodeUrl from 'ace-builds/src-noconflict/theme-monokai.js?url';
import modePythonUrl from 'ace-builds/src-noconflict/mode-python?url';

ace.config.setModuleUrl('ace/mode/python', modePythonUrl);
ace.config.setModuleUrl('ace/theme/xcode', themeXCodeUrl);
ace.config.setModuleUrl('ace/theme/monokai', monokaiCodeUrl);

const modes = {
  py: 'ace/mode/python',
};

const saveEditorContent = function (name, editor) {
  localStorage.setItem('code-block-' + name, editor.session.getValue());
};

const initializeEditor = (name, code) => {
  const editorElement = document.getElementById(name);
  if (editorElement) {
    window[name] = ace.edit(document.getElementById(name), {
      useWorker: false,
      mode: modes['py'],
      theme: document.body.classList.contains('dark')
        ? 'ace/theme/monokai'
        : 'ace/theme/xcode',
      minLines: 1,
      fontSize: 14,
      enableAutoIndent: true,
      value: code,
      showGutter: true,
      showLineNumbers: true,
    });
    window[name].setOptions({
      autoScrollEditorIntoView: false,
      showPrintMargin: false,
    });
    window[name].container.classList.add('code-block-editor');
    window[name].session.on('change', (delta) => {
      _.debounce(saveEditorContent, 10)(name, window[name]);
    });
    document.addEventListener('setTheme', function (e) {
      window[name].setTheme(
        e.detail === 'dark' ? 'ace/theme/monokai' : 'ace/theme/xcode',
      );
    });
  }
  return window[name].session;
};

window.initializeEditor = initializeEditor;
